import { memo, useRef } from "react"
import { useTranslation } from "react-i18next"
import makeStyles from "@material-ui/core/styles/makeStyles"

import TableCell from "@material-ui/core/TableCell"
import TableRow from "@material-ui/core/TableRow"
import Checkbox from "@material-ui/core/Checkbox"
import Box from "@material-ui/core/Box"

import IconButton from "@material-ui/core/IconButton"
import EditIcon from "@material-ui/icons/Edit"
import DeleteIcon from "@material-ui/icons/Delete"
import CheckCircleIcon from "@material-ui/icons/CheckCircle"
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked"

import { ActionCreators, useAdminDispatch } from "../Context"
import { CompanyAvatar } from "components/partials"
import Users from "./Users"
import Catalogs from "./Catalogs"

const useStyles = makeStyles(theme => ({
    disabled: {
        opacity: theme.palette.action.disabledOpacity
    }
}))

const Row = props => {
    const { t } = useTranslation()
    const { data } = props
    const dispatch = useAdminDispatch()
    const classes = useStyles()
    const rowEl = useRef(null)

    function onClickEdit(event) {
        // Prevents edit modal shows, when double-clicking
        // +n more element's dialog.
        if (rowEl.current && !rowEl.current.contains(event.target)) return

        dispatch(ActionCreators.setToEdit(data))
    }

    function onClickDelete() {
        dispatch(ActionCreators.setToDelete([data]))
    }

    function onCheckboxChange() {
        dispatch(ActionCreators.toggleSelect(data))
    }

    const {
        name,
        userLicenses,
        unlimitedUserLicenses,
        catalogLicenses,
        unlimitedCatalogLicenses,
        totalOwnedCatalogs,
        isSelected,
        enabled
    } = data
    const EnabledIcon = enabled ? CheckCircleIcon : RadioButtonUncheckedIcon
    const users = data.users.map(user => ({ ...user, company: data }))

    return (
        <TableRow
            ref={rowEl}
            selected={isSelected}
            onDoubleClick={onClickEdit}
            {...(!enabled && { className: classes.disabled })}
        >
            <TableCell padding="checkbox">
                <Checkbox
                    color="primary"
                    checked={isSelected}
                    onChange={onCheckboxChange}
                />
            </TableCell>

            <TableCell component="th" scope="row">
                <Box display="flex" alignItems="center" gridGap={8}>
                    <CompanyAvatar company={data} />
                    {name}
                </Box>
            </TableCell>

            <TableCell>
                <Users max={3} company={data} users={users} />
            </TableCell>

            <TableCell align="center">
                {`${users.length}/${unlimitedUserLicenses ? t("general.unlimited") : userLicenses
                    }`}
            </TableCell>

            <TableCell>
                <Catalogs max={3} company={data} />
            </TableCell>

            <TableCell align="center">
                {`${totalOwnedCatalogs}/${unlimitedCatalogLicenses ? t("general.unlimited") : catalogLicenses
                    }`}
            </TableCell>

            <TableCell align="center">
                <EnabledIcon fontSize="small" color="primary" />
            </TableCell>

            <TableCell align="right">
                <Box display="flex" justifyContent="flex-end">
                    <IconButton onClick={onClickEdit}>
                        <EditIcon />
                    </IconButton>
                    <IconButton onClick={onClickDelete}>
                        <DeleteIcon />
                    </IconButton>
                </Box>
            </TableCell>
        </TableRow>
    )
}

export default memo(Row)
